import { ConnectionException } from 'src/core/common/domain/exceptions/connection-exception';
import { QueueService } from 'src/core/queue/domain/queue.service';
import { MarkNotificationReadQueueElement } from 'src/core/queue/domain/elements/mark-notification-read-queue-element';
import { Injectable } from '@angular/core';
import { NotificationRepository } from 'src/core/notifications/domain/notification-repository';
import { NotificationsService } from 'src/core/notifications/domain/notifications.service';

@Injectable({
  providedIn: 'any',
})
export class MarkNotificationRead {
  constructor(
    private readonly notificationRepository: NotificationRepository,
    private readonly notificationsService: NotificationsService,
    private readonly queueService: QueueService
  ) {}

  async execute(id: string): Promise<void> {
    const storedNotification = this.notificationsService
      .getStoredNotifications()
      .find((notification) => notification.id === id);
    if (storedNotification?.isRead || this.queueService.getPendingNotificationReadIds().includes(id)) {
      return;
    }

    try {
      await this.notificationRepository.markRead(id);
    } catch (exception) {
      if (!(exception instanceof ConnectionException)) {
        throw exception;
      }
      await this.queueService.enqueue(MarkNotificationReadQueueElement.fromNotificationId(id));
    }
    const newlyRead = await this.notificationsService.markStoredAsRead(id);
    if (newlyRead) {
      await this.notificationsService.decrementUnreadCount();
    }
  }
}
